import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import BaseService from "../base/BaseService";
import IParamServices from "../IParamServices";
import { IRecibosEstadisiticaHome } from "@/core/model/sys/IHomeModels";

export default class HomeService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public async RecibosEstadisiticaHome():Promise<IRecibosEstadisiticaHome|null>
  {
    const response:IServiceResponse = await await this.Get('IndexHome/RecibosEstadisiticaHome',null,null,null,true,false,null); 
    if(response.Response)
    {      
      return response.Response;
    }            
    return null;
  }
}